import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { ProductItem } from '~/features/products/types/products.type';

/**
 * 상품 전체 목록 조회 (페이징 없음)
 * @endpoint GET /products
 */
export function getProductsApi() {
  return axiosInstance.get<ApiResponse<ProductItem[]>>('/products');
}
